module.exports = __webpack_public_path__ + "assets/phone-02.deb423da11ef0551b203d4f020f2e158.png";


//////////////////
// WEBPACK FOOTER
// ./app/landingPage/assets/img/device/phone-02.png
// module id = 873
// module chunks = 0